/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Regular
 * 
 * 1 = Pressure
 * 
 * 2 = LabourAndParts
 */
export enum CalibrationType {
  Regular = 0,
  Pressure = 1,
  LabourAndParts = 2
}
